<script>
import { getAdminInfoLogin, getAdvKfQrcode } from '../api/admin'
import { cookie } from '../utils/cookie'
import { storage } from '../utils/storage'
import config from '../config'

const DEFAULT_AVATAR =
  'http://oss.zhishijingling.com/haoliaodata/2023-07-12/22c77731c3ba439fa46020d3f74209c91689150310528_860.jpeg'

export default {
  data() {
    return {
      DEFAULT_AVATAR,
      adminInfo: {},
      // 在线客服二维码弹窗相关状态
      kefuVisible: false,
      kefuLoading: false,
      kefuQrcode: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.loadAdminInfo())
  },
  methods: {
    toInt(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    async loadAdminInfo() {
      this.adminInfo = {}
      try {
        const res = await getAdminInfoLogin({ _t: Date.now() })
        this.adminInfo = res && res.data ? res.data : {}
      } catch (e) {
        this.adminInfo = {}
      }
    },
    // 解析当前绑定代理的 svapid：优先本地缓存，其次全局默认配置
    resolveSvapid() {
      let svapid = storage.get('svapid')
      if (!svapid) {
        try { svapid = cookie.get && cookie.get('svapid') } catch (e) {}
      }
      return svapid || (config && config.svapid) || ''
    },
    // 点击在线客服：拉取绑定代理的客服二维码并弹窗展示
    async showKefu() {
      if (this.kefuLoading) return
      const svapid = this.resolveSvapid()
      if (!svapid) {
        if (this.$createToast) {
          this.$createToast({ type: 'warn', time: 1500, txt: '缺少代理信息：svapid' }).show()
        }
        return
      }
      this.kefuLoading = true
      try {
        const res = await getAdvKfQrcode({ svapid })
        const url = res && res.data ? res.data : ''
        if (!url) {
          if (this.$createToast) {
            this.$createToast({ type: 'warn', time: 1500, txt: '该代理暂未配置客服二维码' }).show()
          }
          return
        }
        this.kefuQrcode = url
        this.kefuVisible = true
      } catch (e) {
        if (this.$createToast) {
          this.$createToast({ type: 'error', time: 1500, txt: '获取客服二维码失败' }).show()
        }
      } finally {
        this.kefuLoading = false
      }
    },
    closeKefu() {
      this.kefuVisible = false
    }
  }
}
</script>

<template>
  <div >
    <div class="header">
      <div class="header_info">
        <div class="header_info_inner">
          <div class="info_box c-flex">
            <div class="avator c-flex">
              <img :src="adminInfo.headimgurl || DEFAULT_AVATAR">
              <div >
                <div class="info-name">{{ adminInfo.username || '' }}</div>
                <div class="info-bid">ID:{{ adminInfo.bid || '' }}</div>
                <div class="my_desc" @click="goUrl('/center/muthhome?adminid='+adminInfo.id)">我的主页 &gt;</div></div>
            </div>
            <div class="info-right c-flex">
              <div class="r_item">
                <div >待判定</div>
                <div class="num">{{ toInt(adminInfo.pdBalance) }}</div>
              </div>
              <div class="r_item">
                <div >可提现金额</div>
                <div class="num">{{ toInt(adminInfo.usebalance) }}</div>
              </div>
            </div>
          </div>
          <div class="btn_box c-flex">
            <a href="/center/goTx" class="btn withdraw c-flex">
              <img src="https://oss.zhishijingling.com/jinriyouliao/moneyBag.png" class="icon">
              <span >提现</span>
            </a>
            <a href="/center/recharge" class="btn chart c-flex">
              <img src="https://oss.zhishijingling.com/jinriyouliao/card.png" class="icon">
              <span >充值</span>
            </a>
          </div>
          <div class="msg_box c-flex">
            <div class="item" @click="goUrl('/center/myfanslist')">
              <img src="https://oss.zhishijingling.com/jinriyouliao/fans.png" class="icon">
              <span >粉丝{{ toInt(adminInfo.fansCount) }}</span></div>
            <div class="item" @click="goUrl('/center/followList')">
              <img src="https://oss.zhishijingling.com/jinriyouliao/heart.png" class="icon">
              <span >关注{{ toInt(adminInfo.followCount) }}</span></div>
          </div>
          <div class="msg_box c-flex" style="border-top: 1px solid rgb(231, 231, 231);">
            <div class="item">总收入: {{ toInt(adminInfo.amount) }}元</div>
            <div class="item">今日收入: {{ toInt(adminInfo.todayamount) }}元</div></div>
        </div>
      </div>
    </div>

    <div class="operate-list">
        <div>
          <div class="item" @click="goUrl('/center/setmuthhome')">
            <img src="https://oss.zhishijingling.com/jinriyouliao/mine/mine_label.png" class="i_label">
            <div>
              <div class="icon">
                <img src="https://oss.zhishijingling.com/jinriyouliao/mine/home.png"></div>
              <p>主页设置</p></div>
          </div>
        </div>
      <div>
        <div class="item" @click="goUrl('/center/guideMaterial')">
          <img src="https://oss.zhishijingling.com/jinriyouliao/mine/mine_label.png" class="i_label">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/guanzqode.png"></div>
            <p>导粉素材</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="goUrl('/center/battleRecord')">
          <img src="https://oss.zhishijingling.com/jinriyouliao/mine/mine_label.png" class="i_label">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/zhanji.png"></div>
            <p>战绩表</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="goUrl('/center/setBackground')">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/xifen.png"></div>
            <p>料码背景图设置</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="goUrl('/center/setContentBackground')">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/baoci.png"></div>
            <p>料内容底部设置</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="goUrl('/center/setting')">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/settings.png"></div>
            <p>个人设置</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="goUrl('/center/revenue')">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/shouru.png"></div>
            <p>收入明细</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="goUrl('/center/withdrawal')">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/tixian.png"></div>
            <p>提现明细</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="goUrl('/center/bindAccount')">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/bind_more.png"></div>
            <p>多账号绑定</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="showKefu">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/kefu.png"></div>
            <p>在线客服</p></div>
        </div>
      </div>
      <div>
        <div class="item" @click="goUrl('/mine/promotionauthor')">
          <div>
            <div class="icon">
              <img src="https://oss.zhishijingling.com/jinriyouliao/mine/qianxi.png"></div>
            <p>设置推广</p></div>
        </div>
      </div>
    </div>
    <div class="footer_tip">
      <a href="https://mp.weixin.qq.com/s?__biz=MzkyNDM1MDQwMw==&amp;mid=2247483657&amp;idx=1&amp;sn=5028e146cfb2b16831e8f818f5e503bc&amp;chksm=c1d663a5f6a1eab332acedb5eaa10bb9b95703eb2865f678706c119ac70c1089bd960db5bf85#rd">服务条款/免责申明</a></div>
    <div >
      <bottom-tab-bar />
    </div>

    <!-- 在线客服二维码弹窗 -->
    <div v-if="kefuVisible" class="kefu-mask" @click="closeKefu">
      <div class="kefu-popup" @click.stop>
        <div class="kefu-title">扫码联系客服</div>
        <img class="kefu-qrcode" :src="kefuQrcode" alt="客服二维码">
        <div class="kefu-tip">长按二维码可保存到相册</div>
        <div class="kefu-close" @click="closeKefu">关闭</div>
      </div>
    </div>
    </div>
</template>

<style scoped>
.content{
  margin: 0 -10px
}

.saller{
  background: #fff;
  margin-top: .8333rem;
  padding: 1.75rem 1.5833rem
}

.saller .s_header{
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  text-align: left;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between
}

.saller .s_header .s_h_left .s_h_l_title{
  font-size: 1.5rem;
  color: #1f1d1d;
  line-height: 2rem
}

.saller .s_header .s_h_left .s_h_l_desc{
  font-size: 1.1667rem;
  color: #c0bebe;
  line-height: 1.6667rem;
  margin-top: .5rem
}

.saller .s_header .s_h_right{
  font-size: 1.25rem;
  color: #fff;
  height: 2.5rem;
  line-height: 2.5rem;
  padding: 0 1.25rem;
  border-radius: 2.5rem;
  background: #e4aa4b
}

.saller .s_list{
  margin-top: .8333rem;
  padding: 0 1.4583rem;
  width: 25.2917rem;
  height: 3.75rem;
  line-height: 3.75rem;
  background: #f5f4f4;
  border-radius: .3333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  text-align: left;
  position: relative
}

.saller .s_list .s_l_left{
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 1.1667rem;
  color: #1f1d1d
}

.saller .s_list .s_l_left span{
  margin-left: .8333rem
}

.saller .s_list .cubeic-close{
  position: absolute;
  right: 1.4583rem
}

/* .header{
  background: #fff;
  padding: 0 1.6667rem;
  padding-bottom: .8333rem;
  padding-top: 1.25rem
} */

.upload{
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between
}

.input{
  margin-bottom: 1.5833rem;
  text-align: left
}

.input:last-of-type {
  border: none
}

.input .i_input{
  margin-top: .8333rem
}

.input .i_title{
  font-size: 1.25rem;
  color: #1f1d1d
}

.input .cube-input,.input .cube-textarea{
  font-size: 1.25rem
}

.input .cube-input:after,.input .cube-textarea:after {
  display: none
}

.make-btn{
  width: 80%;
  height: 3.333333rem;
  line-height: 3.333333rem;
  border-radius: .3rem;
  margin: 0 auto;
  font-size: 1.166667rem;
  background-color: #f74905;
  -webkit-box-shadow: .041667rem .041667rem .208333rem 0 rgba(247, 73, 5, 0.35);
  box-shadow: .041667rem .041667rem .208333rem 0 rgba(247, 73, 5, 0.35);
  padding-top: 0;
  margin-top: 2.5rem
}

.editor{
  padding: 2.0833rem
}

.editor .input{
  margin-bottom: 1.6667rem
}

.editor .input:last-of-type {
  margin-bottom: 0
}

.editor .input .i_title{
  text-align: left;
  font-size: 1.25rem;
  margin-bottom: .8333rem
}

.editor .input .i_input{
  border: 1px solid #d3d3d3;
  border-radius: .4167rem;
  overflow: hidden
}

.cube-upload-btn-def {
  background-image: url(https://oss.zhishijingling.com/jinriyouliao/uploadPic.png);
  background-size: cover
}

.cube-upload-btn-def i {
  display: none
}

/* 在线客服二维码弹窗 */
.kefu-mask{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  z-index: 9999
}

.kefu-popup{
  width: 22rem;
  background: #fff;
  border-radius: .8333rem;
  padding: 1.6667rem 1.25rem;
  text-align: center;
  box-sizing: border-box
}

.kefu-title{
  font-size: 1.3333rem;
  color: #1f1d1d;
  margin-bottom: 1.25rem
}

.kefu-qrcode{
  width: 16rem;
  height: 16rem;
  object-fit: contain;
  display: block;
  margin: 0 auto
}

.kefu-tip{
  font-size: 1rem;
  color: #999;
  margin-top: .8333rem
}

.kefu-close{
  margin-top: 1.25rem;
  height: 3rem;
  line-height: 3rem;
  border-radius: 3rem;
  background: #f74905;
  color: #fff;
  font-size: 1.1667rem
}

</style>



// WEBPACK FOOTER //
// src/components/center.vue